import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const AddFine = () => {
    const [amount, setAmount] = useState('');
    const [transactionType, setTransactionType] = useState('OUTGOING'); // Default to "OUTGOING"
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState(false); // To handle loading state
    const [error, setError] = useState(''); // To handle error state
    const navigate = useNavigate();

    // Get the staff_id dynamically (from localStorage or context)
    const staffId = 1; // Assuming staff_id is stored in localStorage

    // If staff_id is not found in localStorage, redirect to login page or show an error
    if (!staffId) {
        alert('You must be logged in to add a fine transaction');
        navigate('/login'); // Adjust the route as needed
        return null;
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        // Check if all required fields are filled
        if (!amount || !description) {
            setError('Please fill in all the fields.');
            return;
        }

        setLoading(true);
        setError(''); // Reset error message

        // Prepare the data to be sent in the request body
        const transactionData = {
            staff_id: staffId, // Use the dynamic staff_id
            amount: parseFloat(amount), // Convert amount to float
            transaction_type: 'INCOMING',
            description: description,
        };

        // Make the API request to add the fine transaction
        fetch(`${BASE_URL}fine/transaction`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(transactionData),
        })
        .then((response) => response.json())
        .then((data) => {
            setLoading(false);
            if (data.status === 1) {
                alert('Transaction added successfully!');
                navigate('/FineList'); // Navigate to the FineList page after success
            } else {
                setError(data.message || 'Failed to add transaction.');
            }
        })
        .catch((error) => {
            setLoading(false);
            console.error('Error adding transaction:', error);
            setError('There was an error adding the transaction.');
        });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Fine Received </h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Fine Transaction Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h4>Add Fine Received </h4>
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-danger" onClick={() => navigate('/FineList')}>Back to List</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                {error && <div className="alert alert-danger">{error}</div>}

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label">Gram</label>
                                        <input
                                            type="number"
                                            id="amount"
                                            className="form-control"
                                            value={amount}
                                            onChange={(e) => setAmount(e.target.value)}
                                            required
                                        />
                                    </div>
                                    
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                            {loading ? 'Saving...' : 'Save Transaction'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddFine;
